import React, { Component } from 'react';
import './NumericalKeyboard.css';
import ParameterErrors from '../errors/ParameterErrors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faBackspace} from '@fortawesome/free-solid-svg-icons';
import KeyboardButton from './KeyboardButton';
import HashSource from '../core/HashSource';
import Urls from '../urls/Urls';
const  {throwNotProvided} = ParameterErrors;
export default class NumericalKeyboard extends Component {
	constructor(props){
		super(props);
		const {onKey}=props;
		if(onKey===undefined||onKey===null)throwNotProvided('onKey');
		this._onKey=onKey;
		this._handleClickKeyboardButton = this._handleClickKeyboardButton.bind(this);
		this._createButton = this._createButton.bind(this);
	}
	_handleClickKeyboardButton(key){
		this._onKey(key);
	}
	_createButton(text, imgUrl, value, additionalClasses){
		const className = "keyboard-button-wrapper"+(additionalClasses?(' '+additionalClasses):'');
		return (<div className={className} key={HashSource.next()}>
					<KeyboardButton text={text?text:null} imgUrl={imgUrl?imgUrl:null} value={value} 
					onClick={this._handleClickKeyboardButton}></KeyboardButton></div>);
	}
	render() {
		const keyboardButtons = [];
		/*
		for(var i=7; i>0; i-=3){
			for(var j=i; j<i+3; j++){
				keyboardButtons.push(this._createButton(String(j), null, 48+j));
			}
		}
		
		*/
		for(var i=1; i<10; i++){
			keyboardButtons.push(this._createButton(String(i), null, 48+i));
		}
		keyboardButtons.push((<div className="keyboard-button-wrapper" key={HashSource.next()}/>));
		keyboardButtons.push(this._createButton(String(0), null, 48));
		//keyboardButtons.push((<div className="keyboard-button-wrapper" key={HashSource.next()}/>));
		keyboardButtons.push(this._createButton(null, Urls.assets+'icons/UI_Button_Filter_Clear.png', 8, 'backspace'));
		return (<div className="numerical-keyboard">
			{keyboardButtons}
		</div>);
	}
}
